/** Currency + number formatting helpers (THB). */

const thbFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0,
});

/** e.g. 3000000 -> "฿3,000,000" */
export function formatCurrency(value: number): string {
  const sign = value < 0 ? '-' : '';
  return `${sign}฿${thbFormatter.format(Math.abs(Math.round(value)))}`;
}

/** Compact form for HUD, e.g. 3000000 -> "฿3.0M" */
export function formatCurrencyCompact(value: number): string {
  const abs = Math.abs(value);
  const sign = value < 0 ? '-' : '';
  if (abs >= 1_000_000) return `${sign}฿${(abs / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000) return `${sign}฿${(abs / 1_000).toFixed(1)}K`;
  return `${sign}฿${Math.round(abs)}`;
}

export function formatPercent(value: number, decimals = 0): string {
  return `${value.toFixed(decimals)}%`;
}
